import React, { Component } from 'react'
import autoBind from 'auto-bind'
import PropTypes from 'prop-types'

/** Import imges */
import logoPTM from '../../resources/images/header-ptm.png'
import logoMPV from '../../resources/images/header-mpv.png'

import IconButton from '@material-ui/core/IconButton'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'

import { COMPANY_PTM, COMPANY_MPV } from '../../store/helpers/ResourcesHelper'

/**
 * Component to get header logos by company
 */
export default class HeaderLogosCompany extends Component {
	/**
	 *Creates an instance of HeaderLogosCompany.
	 * @param {*} props
	 * @memberof HeaderLogosCompany
	 */
	constructor(props) {
		super(props)
		autoBind(this)
	}

	/**
	 * Method to get the header logo by company
	 */
	getLogoByCompany() {
		const { companyIdentifier } = this.props
		if (companyIdentifier) {
			switch (companyIdentifier) {
				case COMPANY_PTM:
					return <img className='logoheader-sip' src={logoPTM} alt='logoheader' />
				case COMPANY_MPV:
					return <img className='logoheader-sip' src={logoMPV} alt='logoheader' />
				default:
					return <img className='logoheader-sip' src={logoMPV} alt='logoheader' />
			}
		} else {
			return <img className='logoheader-sip' src={logoPTM} alt='logoheader' />
		}
	}

	/**
	 * Render heade logo
	 */
	render() {
		return (
			<div style={{ display: 'contents' }}>
				{this.getLogoByCompany()}
				<IconButton onClick={this.props.onClose} style={{ position: 'absolute' }}>
					<ChevronLeftIcon />
				</IconButton>
			</div>
		)
	}
}

/**
 * FooterContainer
 */
HeaderLogosCompany.propTypes = {
	companyIdentifier: PropTypes.string,
}
